import React from 'react';
import './AddToHomeModal.scss';
import Modal from '../../../Components/Common/Modal/Modal';

const AddToHomeModal = ({ isOpen, onClose }) => {
    const isAndroid = /android/i.test(navigator.userAgent);
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            modalClass="add-to-home-modal"
            footer={null}
            closable={false}
            centered={false}
            transitionName=""
        >
            <div className="modal-body">
                <h2>Simplify your EV Charging</h2>
                <p>
                    Add LionCharge App to your home screen and access an app-like
                    experience without using storage space.
                </p>
                <ol>
                    {isAndroid ? (
                        <>
                            <li>
                                Tap the <strong>three-dot menu (⋮)</strong> in the
                                top-right corner.
                            </li>
                            <li>
                                Select <strong>"Add to Home screen"</strong>.
                            </li>
                            <li>
                                Tap <strong>"Add"</strong> in the prompt.
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                Tap the <strong>Share icon</strong> (square with arrow).
                            </li>
                            <li>
                                Scroll down and select{' '}
                                <strong>"Add to Home Screen"</strong>.
                            </li>
                            <li>
                                Tap <strong>"Add"</strong> in the top-right corner.
                            </li>
                        </>
                    )}
                </ol>
                <button className="modal-button" onClick={onClose}>
                    Remind Me Later
                </button>
            </div>
        </Modal>
    );
};

export default AddToHomeModal;
